import { Table, useMantineTheme } from "@mantine/core"

import { TraceabilityRequestOperation } from "~/pages/SupplierPortal/TraceabilityRequests/components/TraceabilityRequestOperation.tsx"
import { TraceabilityOperationsProvider } from "~/pages/SupplierPortal/TraceabilityRequests/context/TraceabilityOperationsContext"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"
import { OperationItem } from "~/pages/SupplierPortal/TraceabilityRequests/utils.ts"

type Props = {
  index: number
  operationsItemWithRowspan: (
    | { op: OperationItem; rowspan: number }
    | "no-op"
  )[]
}

export function TraceabilityRequestItem({
  index,
  operationsItemWithRowspan,
}: Props) {
  const { colors } = useMantineTheme()
  const { request, status, setProgress } = useInformationRequestContext()

  return (
    <Table.Tr
      data-testid={`IrRow:${index}`}
      key={`${request.original.id}-row-${index}`}
    >
      {operationsItemWithRowspan.map((operationItemWithRowspan, index) => {
        if (operationItemWithRowspan === "no-op") {
          return null
        }
        const operationItem = operationItemWithRowspan.op

        return (
          <Table.Td
            data-testid={`IrColumn:${index}`}
            rowSpan={operationItemWithRowspan.rowspan}
            key={`${request.original.id}-cell-${operationItem.nodeId}`}
            valign="top"
            maw={350}
            miw={350}
            bd={`1px ${colors.gray[3]} solid`}
          >
            <TraceabilityOperationsProvider
              request={request}
              status={status}
              operationItems={request.opItems}
              operationItem={operationItem}
              setProgress={setProgress}
            >
              <TraceabilityRequestOperation />
            </TraceabilityOperationsProvider>
          </Table.Td>
        )
      })}
    </Table.Tr>
  )
}
